import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const BudgetPopup = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("popup_dismissed")) return;
    const timer = setTimeout(() => setVisible(true), 30000);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem("popup_dismissed", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-foreground/40 backdrop-blur-sm animate-fade-in">
      <div className="bg-card rounded-xl shadow-2xl p-8 max-w-md w-full mx-4 relative">
        <button onClick={dismiss} className="absolute top-3 right-3 text-muted-foreground hover:text-foreground" aria-label="Fechar">
          <X className="h-5 w-5" />
        </button>
        <h3 className="text-xl font-bold mb-2" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          Quer reduzir custos com portaria?
        </h3>
        <p className="text-muted-foreground text-sm mb-6">
          Solicite um orçamento gratuito e descubra quanto seu condomínio pode economizar com portaria remota inteligente.
        </p>
        <div className="flex gap-3">
          <Button asChild className="flex-1 bg-accent text-accent-foreground hover:bg-accent/90">
            <Link to="/contato" onClick={dismiss}>Solicitar Orçamento</Link>
          </Button>
          <Button variant="outline" onClick={dismiss} className="flex-1">
            Agora não
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BudgetPopup;
